import './index.css'

import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import { defineComponents } from './scripts/utils/define-components'

document.fonts.ready.then(() => {
  defineComponents()
})
